// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".equipment-link[data-v-6d4ed3dd] {\n  font-family: \"Helvetica Neue LT Std\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 14px;\n  list-style-type: none;\n  margin-right: 10px;\n  width: 100%;\n}\n.equipment-link a[data-v-6d4ed3dd] {\n  text-decoration: none;\n  color: #007eeb;\n}\n.equipment-link a[data-v-6d4ed3dd]:visited {\n  color: #007eeb;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
